import React from 'react';
import { motion } from 'framer-motion';
import '../csscomponent/LegalPages.css';

const terms = [
  {
    title: 'Acceptance of Terms',
    text: 'By using this website or requesting services, you agree to these Terms of Service and all applicable laws.',
  },
  {
    title: 'Service Engagement',
    text: 'Final scope, timeline, and pricing are defined in written agreements or package selections confirmed between both parties.',
  },
  {
    title: 'Payments and Deliverables',
    text: 'Payments must follow approved milestones. Deliverables are released according to agreed project phases and completion criteria.',
  },
  {
    title: 'Client Content and Approvals',
    text: 'You confirm that submitted assets (text, logos, images, media) are lawful and owned or licensed for use in your project.',
  },
  {
    title: 'Limitation of Liability',
    text: 'Services and Developer is not liable for indirect damages, third-party outages, or misuse of deliverables outside intended scope.',
  },
  {
    title: 'Termination',
    text: 'Either party may terminate an engagement for material breach, non-payment, or legal non-compliance under contract terms.',
  },
  {
    title: 'Changes to Terms',
    text: 'We may update these terms periodically. Continued use of the site or services after updates implies acceptance of revised terms.',
  },
];

function TermsOfService() {
  return (
    <section className="legal-page">
      <motion.div
        className="legal-hero"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55 }}
      >
        <p>Terms of Service</p>
        <h1>Service terms for clients and website users</h1>
        <span>
          These terms govern how Services and Developer delivers web design, development, optimization,
          and product-related services showcased across this site.
        </span>
      </motion.div>

      <div className="legal-grid">
        {terms.map((item, index) => (
          <motion.article
            key={item.title}
            className="legal-card"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: index * 0.08 }}
          >
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </motion.article>
        ))}
      </div>

      <p className="legal-note">Last updated: February 23, 2026</p>
    </section>
  );
}

export default TermsOfService;
